import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMusic,
  faPlay,
  faPlus,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

/**
 * List row for playlists, browse groups, personalities.
 * [thumbnail + play/+]  name / subtitle                    >
 */
export default function QueueSourceListRow({
  coverUrl = '',
  fallbackIcon = faMusic,
  thumbClassName = '',
  thumbContent = null,
  name,
  subtitle,
  isActive = false,
  canPlay = true,
  appendMode = false,
  onPlay,
  onOpen,
  trailing = null,
  playLabel,
  addLabel,
  className = '',
}) {
  const actionLabel = appendMode
    ? (addLabel || `Add ${name} to queue`)
    : (playLabel || `Play ${name}`);

  return (
    <li
      className={[
        'music-playlist-row',
        'music-queue-source-row',
        isActive ? 'is-active' : '',
        className,
      ].filter(Boolean).join(' ')}
    >
      <div className="music-playlist-thumb-wrap">
        <button
          type="button"
          className={['music-playlist-thumb', thumbClassName].filter(Boolean).join(' ')}
          onClick={() => (canPlay ? onPlay?.() : onOpen?.())}
          aria-label={canPlay ? actionLabel : `Open ${name}`}
        >
          {thumbContent || (
            <>
              <div className="music-playlist-thumb-fallback">
                <FontAwesomeIcon icon={fallbackIcon} />
              </div>
              {coverUrl && <img src={coverUrl} alt="" />}
            </>
          )}
        </button>
        {canPlay && (
          <span
            className={[
              'music-playlist-thumb-action',
              appendMode ? 'is-add' : 'is-play',
            ].join(' ')}
            aria-hidden="true"
          >
            <FontAwesomeIcon icon={appendMode ? faPlus : faPlay} />
          </span>
        )}
      </div>

      <button
        type="button"
        className="music-playlist-meta music-playlist-meta-btn"
        onClick={() => onOpen?.()}
      >
        <div className="music-playlist-name">{name}</div>
        {subtitle && <div className="music-playlist-count">{subtitle}</div>}
      </button>

      {trailing}

      <button
        type="button"
        className="music-playlist-row-chevron"
        onClick={() => onOpen?.()}
        aria-label={`Open ${name}`}
        title={`Open ${name}`}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </li>
  );
}
